import { Controller } from '@hotwired/stimulus'

// Simple sortable controller for reordering items via drag and drop
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.initSortable()
  }

  initSortable() {
    const items = this.element.querySelectorAll('[data-sortable-handle]')

    items.forEach((handle) => {
      const item = handle.closest('[id^="service-"]')
      if (!item) return

      item.setAttribute('draggable', 'true')

      item.addEventListener('dragstart', (e) => this.handleDragStart(e, item))
      item.addEventListener('dragover', (e) => this.handleDragOver(e))
      item.addEventListener('drop', (e) => this.handleDrop(e, item))
      item.addEventListener('dragend', (e) => this.handleDragEnd(e))
    })
  }

  handleDragStart(e, item) {
    this.draggedItem = item
    item.classList.add('opacity-50')
    e.dataTransfer.effectAllowed = 'move'
    e.dataTransfer.setData('text/plain', item.id)
  }

  handleDragOver(e) {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'move'

    const target = e.target.closest('[id^="service-"]')
    if (target && target !== this.draggedItem) {
      const rect = target.getBoundingClientRect()
      const midY = rect.top + rect.height / 2

      if (e.clientY < midY) {
        target.classList.add('border-t-2', 'border-primary-500')
        target.classList.remove('border-b-2')
      } else {
        target.classList.add('border-b-2', 'border-primary-500')
        target.classList.remove('border-t-2')
      }
    }
  }

  handleDrop(e, target) {
    e.preventDefault()

    if (target && target !== this.draggedItem) {
      const rect = target.getBoundingClientRect()
      const midY = rect.top + rect.height / 2

      if (e.clientY < midY) {
        target.parentNode.insertBefore(this.draggedItem, target)
      } else {
        target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
      }

      this.saveOrder()
    }

    this.clearDropIndicators()
  }

  handleDragEnd(_e) {
    this.draggedItem?.classList.remove('opacity-50')
    this.clearDropIndicators()
  }

  clearDropIndicators() {
    this.element.querySelectorAll('[id^="service-"]').forEach((item) => {
      item.classList.remove('border-t-2', 'border-b-2', 'border-primary-500')
    })
  }

  saveOrder() {
    const serviceIds = Array.from(this.element.querySelectorAll('[id^="service-"]'))
      .map((item) => item.id.replace('service-', ''))

    if (this.urlValue) {
      fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ service_ids: serviceIds })
      })
    }
  }
}
